<template>
    <div class="jdoc-page">
        <!-- ==================== 顶部模式栏：滚动时始终可见 ==================== -->
        <div class="jdoc-modebar">
            <div class="jdoc-modebar__brand">
                <span class="jdoc-modebar__icon">
                    <el-icon>
                        <Memo />
                    </el-icon>
                </span>
                <span class="jdoc-modebar__text">
                    <span class="jdoc-modebar__title">代码注释</span>
                    <span class="jdoc-modebar__sub">检索 Java 类与方法的结构化注释，可按工程、目录、包逐层浏览</span>
                </span>
            </div>
            <div class="jdoc-seg" role="tablist">
                <button type="button" class="jdoc-seg__item" :class="{ 'is-active': pageMode == 'search' }" @click="pageMode = 'search'">
                    <el-icon class="jdoc-seg__icon">
                        <Search />
                    </el-icon>
                    <span>搜索</span>
                </button>
                <button type="button" class="jdoc-seg__item" :class="{ 'is-active': pageMode == 'file' }" @click="pageMode = 'file'">
                    <el-icon class="jdoc-seg__icon">
                        <FolderOpened />
                    </el-icon>
                    <span>目录</span>
                </button>
                <button type="button" class="jdoc-seg__item" :class="{ 'is-active': pageMode == 'view' }" @click="pageMode = 'view'">
                    <el-icon class="jdoc-seg__icon">
                        <Grid />
                    </el-icon>
                    <span>浏览</span>
                </button>
                <!-- TAG 页面尚未实现（后端也没有对应接口），先隐藏入口，待页面实现后再放开
                <button type="button" class="jdoc-seg__item" :class="{ 'is-active': pageMode == 'tag' }" @click="pageMode = 'tag'">
                    <el-icon class="jdoc-seg__icon">
                        <PriceTag />
                    </el-icon>
                    <span>TAG</span>
                </button>
                -->
            </div>
        </div>

        <!-- ==================== 内容区域 ==================== -->
        <div class="jdoc-body">
            <java-doc-search-page v-if="pageMode == 'search'" />
            <java-doc-file-page v-else-if="pageMode == 'file'" />
            <java-doc-view-page v-else-if="pageMode == 'view'" />
        </div>
    </div>
</template>

<script>
import JavaDocViewPage from './components/JavaDocViewPage';
import JavaDocSearchPage from './components/JavaDocSearchPage';
import JavaDocFilePage from './components/JavaDocFilePage';
export default {
    data() {
        return {
            pageMode: 'search'
        };
    },
    components: { JavaDocSearchPage, JavaDocViewPage, JavaDocFilePage },
    mounted() {
        document.title = 'Hidoc-代码注释';
    }
};
</script>

<style>
/* ==================================================================================
   JavaDoc 模块公共视觉（非 scoped：子组件与 teleport 到 body 的弹窗都要用到）
   与工作台保持一致的设计语言：主色 #2f6fed、圆角卡片、统一文本层级
   ================================================================================== */
.jdoc-page,
.jdoc-dialog {
    /* 局部覆盖主色，使本模块与其它页面的视觉语言统一 */
    --el-color-primary: #2f6fed;
    --el-color-primary-light-3: #6d9af2;
    --el-color-primary-light-5: #97b7f6;
    --el-color-primary-light-7: #c1d4fa;
    --el-color-primary-light-8: #d5e2fb;
    --el-color-primary-light-9: #eaf1fd;
    --el-color-primary-dark-2: #2659be;

    --jdoc-text: #1f2d3d;
    --jdoc-sub: #5b6a80;
    --jdoc-muted: #aab4c4;
    --jdoc-line: #e6eaf0;
    --jdoc-soft: #f5f7fb;
}

.jdoc-page {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    height: 100%;
    font-size: 14px;
    color: var(--jdoc-text);
}

/* ---------- 顶部模式栏 ---------- */
.jdoc-modebar {
    display: flex;
    flex: none;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 10px 14px;
    border: 1px solid #ebeef5;
    border-radius: 12px;
    background: linear-gradient(180deg, #ffffff 0%, #fafbfd 100%);
    box-shadow: 0 10px 28px -22px rgba(31, 45, 61, 0.55);
}

.jdoc-modebar__brand {
    display: flex;
    align-items: center;
    min-width: 0;
}

.jdoc-modebar__icon {
    display: flex;
    flex: none;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    margin-right: 10px;
    border-radius: 10px;
    font-size: 18px;
    color: #fff;
    background: linear-gradient(135deg, #6a9cff 0%, #2f6fed 100%);
    box-shadow: 0 8px 16px -10px rgba(47, 111, 237, 0.9);
}

.jdoc-modebar__text {
    display: flex;
    flex-direction: column;
    min-width: 0;
}

.jdoc-modebar__title {
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    color: var(--jdoc-text);
}

.jdoc-modebar__sub {
    font-size: 12px;
    line-height: 16px;
    color: var(--jdoc-muted);
}

/* 分段模式切换：选中态用白底 + 主色文字，一眼可见当前所在页面 */
.jdoc-seg {
    display: flex;
    flex: none;
    gap: 4px;
    padding: 3px;
    border-radius: 10px;
    background-color: #f2f5fa;
}

.jdoc-seg__item {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    height: 32px;
    padding: 0 16px;
    border: 0;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 500;
    font-family: inherit;
    color: var(--jdoc-sub);
    background-color: transparent;
    cursor: pointer;
    transition: background-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
}

.jdoc-seg__item:hover {
    color: var(--jdoc-text);
    background-color: #e8eef7;
}

.jdoc-seg__item.is-active {
    color: var(--el-color-primary);
    background-color: #fff;
    box-shadow: 0 1px 3px rgba(28, 47, 84, 0.14);
}

.jdoc-seg__icon {
    font-size: 15px;
}

/* ---------- 内容区：桌面端内部各自滚动，移动端交给页面整体滚动 ---------- */
.jdoc-body {
    flex: 1 1 auto;
    min-height: 0;
    margin-top: 12px;
}

/* ---------- 通用面板 ---------- */
.jdoc-panel {
    display: flex;
    flex-direction: column;
    min-height: 0;
    border: 1px solid var(--jdoc-line);
    border-radius: 14px;
    background-color: #fff;
    box-shadow: 0 1px 2px rgba(28, 47, 84, 0.05);
}

.jdoc-panel__head {
    display: flex;
    flex: none;
    align-items: center;
    gap: 8px;
    padding: 10px 12px;
    border-bottom: 1px solid var(--jdoc-line);
    font-size: 13px;
    font-weight: 600;
    color: var(--jdoc-text);
}

.jdoc-panel__head .el-icon {
    color: var(--el-color-primary);
}

.jdoc-panel__body {
    flex: 1 1 auto;
    min-height: 0;
    padding: 8px;
    overflow: auto;
}

/* ---------- 通用列表项（工程 / 目录 / 包 / 类） ---------- */
.jdoc-item {
    display: block;
    width: 100%;
    padding: 7px 10px;
    border: 0;
    border-radius: 8px;
    font-size: 13px;
    font-family: inherit;
    line-height: 20px;
    color: var(--jdoc-sub);
    text-align: left;
    background-color: transparent;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    transition: background-color 0.2s ease, color 0.2s ease;
}

.jdoc-item:hover {
    color: var(--jdoc-text);
    background-color: #f2f5fa;
}

.jdoc-item.is-active {
    color: var(--el-color-primary);
    font-weight: 600;
    background-color: var(--el-color-primary-light-9);
}

/* ---------- el-tree 视觉调整 ---------- */
.jdoc-tree .el-tree {
    background-color: transparent;
}

.jdoc-tree .el-tree-node__content {
    height: 32px;
    border-radius: 8px;
    font-size: 13px;
    color: var(--jdoc-sub);
}

.jdoc-tree .el-tree-node__content:hover {
    background-color: #f2f5fa;
}

.jdoc-tree .jdoc-tree__node {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.jdoc-tree .jdoc-tree__node.is-active {
    color: var(--el-color-primary);
    font-weight: 600;
}

/* ---------- 空状态 ---------- */
.jdoc-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 48px 16px;
    text-align: center;
}

.jdoc-empty > .el-icon {
    font-size: 30px;
    color: #c6cfdd;
}

.jdoc-empty__title {
    font-size: 14px;
    color: var(--jdoc-sub);
}

.jdoc-empty__desc {
    font-size: 12px;
    line-height: 18px;
    color: var(--jdoc-muted);
}

/* ---------- 弹窗（teleport 到 body，需要非 scoped 样式） ---------- */
.jdoc-dialog {
    max-width: calc(100vw - 32px);
    border-radius: 14px;
    box-shadow: 0 18px 50px -12px rgba(28, 47, 84, 0.22);
}

.jdoc-dialog .el-dialog__header {
    margin-right: 0;
    padding: 20px 22px 0;
}

.jdoc-dialog .el-dialog__title {
    font-size: 16px;
    font-weight: 600;
    color: var(--jdoc-text);
}

.jdoc-dialog .el-dialog__headerbtn {
    top: 12px;
    right: 12px;
}

.jdoc-dialog .el-dialog__body {
    padding: 16px 22px 6px;
    color: var(--jdoc-text);
}

.jdoc-dialog .el-dialog__footer {
    padding: 0 22px 20px;
}

/* 弹窗内的 markdown 预览：去掉主题左右 2.5rem 内边距，避免窄屏下内容过窄 */
.jdoc-dialog .vuepress-markdown-body {
    padding-left: 0;
    padding-right: 0;
}

/* 代码块自带左右 -1.5rem 负外边距（用于抵扣主题的 2.5rem 内边距），需一并归零，
   否则代码块两侧溢出，行号列与复制按钮会被裁切 */
.jdoc-dialog .vuepress-markdown-body div[class*=v-md-pre-wrapper-] {
    margin-left: 0;
    margin-right: 0;
}

/* ---------- 小尺寸设备适配 ---------- */
@media (max-width: 768px) {
    /* 移动端交给外层页面整体滚动，避免出现双层滚动条 */
    .jdoc-page {
        height: auto;
    }

    .jdoc-modebar {
        padding: 8px 10px;
    }

    .jdoc-modebar__sub {
        display: none;
    }

    .jdoc-seg {
        flex: 1 1 100%;
    }

    .jdoc-seg__item {
        flex: 1 1 0;
        justify-content: center;
        padding: 0 8px;
    }

    .jdoc-body {
        margin-top: 10px;
    }

    .jdoc-empty {
        padding: 32px 12px;
    }

    .jdoc-dialog .el-dialog__header {
        padding: 16px 16px 0;
    }

    .jdoc-dialog .el-dialog__body {
        padding: 12px 16px 4px;
    }

    .jdoc-dialog .el-dialog__footer {
        padding: 0 16px 16px;
    }
}
</style>
